// 手写防抖
export default function debounce(func, wait) {
    let timeout;
    return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            func.apply(this, args);
        }, wait);
    }
};

// 缓存是手机端还是PC端
export const isMobile = () => {
    // 移动端断点
    const MOBILE_BREAK_POINT = 768;
    const width = window.innerWidth;

    return /Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || (width <= MOBILE_BREAK_POINT);
}

// 初始化gamyeap关键信息
export const initIsMobile = () => {
    return isMobile();
}

// 格式化封面信息
export const formatCover = (originalUrl) => {
    // 如果不是阿里云 OSS 的链接，直接返回
    if (!originalUrl || !originalUrl.includes('aliyuncs.com')) {
        return originalUrl;
    }

    try {
        // 1. 从原始 URL 中提取文件名和参数
        const matches = originalUrl.match(/thumbnails%2F([^?]+)(\?[^?]+)?/);
        if (!matches) {
            console.warn('Failed to extract filename from URL:', originalUrl);
            return originalUrl;
        }

        // 2. 获取文件名和参数
        const [, filename, queryParams = ''] = matches;
        
        // 3. 解码并重新编码文件名
        const decodedFilename = decodeURIComponent(filename);
        const encodedFilename = encodeURIComponent(decodedFilename);
        
        // 4. 构建新的路径（保留原始查询参数）
        return `/images/game/thumbnails/${encodedFilename}${queryParams}`;
        
    } catch (error) {
        console.error('Error in formatCover:', error);
        return originalUrl;
    }
};

// 数据清理函数 - 确保所有值都可序列化
export const cleanData = (data) => {
    if (data === undefined) return null;
    if (data === null) return null;
    if (typeof data === 'string') return data;
    if (typeof data === 'number') return data;
    if (typeof data === 'boolean') return data;
    if (Array.isArray(data)) return data.map(cleanData);
    if (typeof data === 'object') {
        const cleaned = {};
        for (const [key, value] of Object.entries(data)) {
            cleaned[key] = cleanData(value);
        }
        return cleaned;
    }
    return null;
};

// 确保图片URL是绝对路径
export const ensureAbsoluteImageUrl = (imageUrl) => {
    if (!imageUrl) return "/images/icons/common/placeholder.jpg";
    
    // 如果已经是绝对URL（包含协议）或者已经以/开头，直接返回
    if (imageUrl.startsWith('http') || imageUrl.startsWith('/')) {
        return imageUrl;
    }
    
    // 如果是相对路径，添加/前缀使其变为绝对路径
    return `/${imageUrl}`;
};

// 格式化游戏数据 - 用于游戏列表
export const formatGameData = (games) => {
    if (!games || !Array.isArray(games)) return [];
    
    return games.map(game => {
        const thumbnailImage = game.images?.filter(image => image.imageType === 'GAME_IMAGE_TYPE_THUMBNAIL')[0];
        const rawImageUrl = thumbnailImage?.imageUrl;
        
        return cleanData({
            id: game.id || 0,
            name: game.name || 'Untitled Game',
            slug: game.slug || '',
            description: game.description || '',
            instructions: game.instructions || '',
            categories: game.categories || [],
            cover_image: ensureAbsoluteImageUrl(rawImageUrl),
            tags: game.tags || [],
            updated_at: game.releaseDate || '',
            loading: false,
            status: game.status || 'UNKNOWN',
        });
    });
};

// 格式化单个游戏数据 - 用于游戏详情页
export const formatSingleGameData = (game) => {
    if (!game) return null;
    
    const thumbnailImage = game.images?.find(image => 
        image.imageType === 'GAME_IMAGE_TYPE_THUMBNAIL'
    );
    
    return cleanData({
        id: game.id || 0,
        name: game.name || 'Untitled Game',
        slug: game.slug || '',
        path: game.slug || '', // 为了兼容现有代码
        description: game.description || '',
        instructions: game.instructions || '',
        categories: game.categories || [],
        cover_image: ensureAbsoluteImageUrl(thumbnailImage?.imageUrl),
        tags: game.tags || [],
        updated_at: game.releaseDate || '',
        status: game.status || 'UNKNOWN',
        playCount: game.playCount || 0,
        likeCount: game.likeCount || 0,
        viewCount: game.viewCount || 0,
        releaseDate: game.releaseDate || '',
        createdAt: game.createdAt || '',
        updatedAt: game.updatedAt || '',
        src: game.gameUrl || ''
    });
};